/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { recruiterAvailabilityShow } from '../../axios/recruiterAvailabilityShow'
import type {
	RecruiterAvailabilityShowError,
	RecruiterAvailabilityShowResponse,
} from '../../types/RecruiterAvailabilityShow'

export const recruiterAvailabilityShowQueryKey = () => [{ url: '/interview-scheduling/availability' }] as const

export type RecruiterAvailabilityShowQueryKey = ReturnType<typeof recruiterAvailabilityShowQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::show */
export function recruiterAvailabilityShowQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		RecruiterAvailabilityShowResponse,
		AxiosError<RecruiterAvailabilityShowError>,
		RecruiterAvailabilityShowResponse,
		RecruiterAvailabilityShowQueryKey
	>({
		queryKey: recruiterAvailabilityShowQueryKey(),
		queryFn: ({ signal }) => recruiterAvailabilityShow({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::show */
export function useRecruiterAvailabilityShow<TSelectData = RecruiterAvailabilityShowResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					RecruiterAvailabilityShowResponse,
					AxiosError<RecruiterAvailabilityShowError>,
					TSelectData,
					RecruiterAvailabilityShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<RecruiterAvailabilityShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...recruiterAvailabilityShowQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::show */
export function useRecruiterAvailabilityShowSuspense<TSelectData = RecruiterAvailabilityShowResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					RecruiterAvailabilityShowResponse,
					AxiosError<RecruiterAvailabilityShowError>,
					TSelectData,
					RecruiterAvailabilityShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<RecruiterAvailabilityShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...recruiterAvailabilityShowQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
